var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3CDBC0",
    d: "M369.125,257.333c-28.109-5.444-53.959-19.106-74.655-39.802c-20.143-20.143-33.62-45.171-39.345-72.41 V414H426.64l-57.515-57.096V257.333z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7F41",
    cx: 397,
    cy: 115,
    r: 115
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7F41",
    cx: 256.125,
    cy: 482,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M390.125,348.572v-88.735c-13.787-0.64-27.222-3.204-40-7.555v112.949L378.105,393H133.388l26.737-27.95 V196.981c0-21.951,7.514-42.572,21.317-59.634c13.429-16.601,32.39-28.323,52.993-33.01l18.315-4.179 c2.847-28.185,13.785-54.617,31.681-76.572C281.494,10.1,269.493,0,255.125,0c-16.57,0-30,13.43-30,30v35.334 c-60,13.648-105,67.418-105,131.647v151.591l-31.714,32.339C82.982,386.34,80,394.215,80,402.5c0,16.57,13.555,30.5,30.125,30.5 h292c16.57,0,29.875-13.93,29.875-30.5c0-8.285-3.732-16.16-9.161-21.589L390.125,348.572z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.3ad3e575853b0b88e48d9107208b48c0.svg";
export { ForwardRef as ReactComponent };